import React from 'react'
import './App.css';
import Index from './home.js';
import Abouts from './about.js';
import Service from './services.js';
import Why from './why.js';
import Map from './map.js';
import Contact from './contact.js';
import Thank from './thankyou.js';

import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink 
} from 'react-router-dom'

const Logo = () => (
    <svg className="svg_logo" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.9 65">
        <title>Asset Logo</title>
        <g id="Layer_2">
          <g id="Layer_1-2">
            <path className="st0" d="M74.3,20.7h3.1l1.1,2.8c2.6-1.6,3.8-3.1,7.4-3.1c3,0,5.5,1.3,6.5,3.4c2.3-1.8,4.6-3.4,8.6-3.4
        c4.5,0,7.3,3.2,7.3,7.9v16.3h-4.2V28.3c0-2.5-1.5-4.1-3.7-4.1c-3.2,0-4.6,0.5-7.2,2.4c0,0,0,1.6,0,1.7v16.4h-4.1V28.3
        c0-2.5-1.6-4.1-3.7-4.1c-3.2,0-3.9,0.8-6.9,2.4v18h-4.2V20.7z"/>
            <polygon className="st0" points="114.3,20.4 121.2,39.2 128.2,20.4 132.7,20.4 123.3,44.6 119,44.6 109.8,20.4 114.3,20.4    "/>
            <path className="st0" d="M148.6,41.2c2.6,0,4.2-1.6,4.2-8.6c0-5.7-1.5-8.3-4.2-8.3c-3,0.1-5.9,0.7-8.6,1.9v13.9
        C142.8,40.8,145.7,41.2,148.6,41.2z M135.9,20.7h3.1l0.9,2.6c2.8-1.6,5.9-2.6,9.1-2.9c6.4,0,7.9,6.2,7.9,12.1
        c0,6.3-1.1,12.4-7.9,12.4c-3.1-0.1-6.2-0.7-9.1-1.7v10.1l-4.1,1L135.9,20.7L135.9,20.7z"/>
            <path className="st0" d="M32.5,3.3C16.4,3.3,3.3,16.4,3.3,32.5s13.1,29.2,29.2,29.2s29.2-13.1,29.2-29.2C61.7,16.4,48.6,3.3,32.5,3.3z
         M32.5,65C14.6,65,0,50.4,0,32.5S14.6,0,32.5,0S65,14.6,65,32.5C65,50.4,50.4,65,32.5,65z"/>
            <path className="st1" d="M32.5,3.3C16.4,3.3,3.3,16.4,3.3,32.5s13.1,29.2,29.2,29.2s29.2-13.1,29.2-29.2C61.7,16.4,48.6,3.3,32.5,3.3z
        "/>
            <polygon className="st2" points="30.5,32.5 32.5,36.3 34.5,32.5 32.5,28.7 30.5,32.5    "/>
            <polygon className="st2" points="43.5,15.8 32.5,23 36.1,29.6 43.5,15.8    "/>
            <path className="st2" d="M21.7,12.6l10.8,7.1l10.8-7.1c-3.5-1.3-7.1-2-10.8-2.1C28.8,10.6,25.2,11.3,21.7,12.6L21.7,12.6z"/>
            <polygon className="st2" points="28.9,29.6 32.5,23 21.5,15.8 28.9,29.6    "/>
            <path className="st2" d="M43.3,52.4l-10.8-7.1l-10.8,7.1c3.5,1.3,7.1,2,10.8,2.1C36.2,54.4,39.8,53.7,43.3,52.4L43.3,52.4z"/>
            <polygon className="st1" points="28.9,35.4 21.5,49.2 32.5,42 28.9,35.4    "/>
            <polygon className="st1" points="32.5,42 43.5,49.2 36.1,35.4 32.5,42    "/>
            <path className="st0" d="M43.5,49.2l-11-7.2l3.6-6.6L43.5,49.2z M21.7,52.4l10.8-7.1l10.8,7.1c-3.5,1.3-7.1,2-10.8,2.1
        C28.8,54.4,25.2,53.7,21.7,52.4L21.7,52.4z M32.5,42l-11,7.2l7.4-13.8L32.5,42z M21.5,15.7l11,7.2l-3.6,6.6L21.5,15.7L21.5,15.7z
         M43.3,12.6l-10.8,7.1l-10.8-7.1c3.5-1.3,7.1-2,10.8-2.1C36.2,10.6,39.8,11.3,43.3,12.6L43.3,12.6z M32.5,23l11-7.2l-7.4,13.8
        L32.5,23z M30.5,32.5l2-3.8l2,3.8l-2,3.8L30.5,32.5z M48.7,12l-1.3-0.6C42.7,9.2,37.7,8,32.5,7.8C27.4,8,22.3,9.2,17.6,11.3
        l-1.3,0.6l11,20.6l-11,20.6l1.3,0.6c4.7,2.2,9.7,3.4,14.9,3.5c5.1-0.2,10.2-1.4,14.9-3.5l1.3-0.6l-11-20.6L48.7,12L48.7,12z"/>
          </g>
        </g>
     </svg>
)


const Nav = () => (
      <nav className="navbar navbar-default">
          <div className="container"> 
            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false"> <span className="sr-only">Toggle navigation</span> <span className="icon-bar"></span> <span className="icon-bar"></span> <span className="icon-bar"></span> </button>
              <Link className="navbar-brand" to="/"><Logo /></Link> 
            </div>
            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
              <ul className="nav navbar-nav navbar-right text-uppercase">
                <li><NavLink to="/about" activeClassName="active">About MVP</NavLink ></li>
                <li><NavLink to="/why" activeClassName="active">Why MVP?</NavLink ></li>
                <li><NavLink to="/services" activeClassName="active">Services</NavLink ></li>
                <li><NavLink to="/map" activeClassName="active">Locations</NavLink ></li>
                <li><NavLink to="/contact" activeClassName="active">Contact</NavLink ></li>
              </ul>
            </div>
          </div>
    </nav>
)

const App = () => (
  <Router>
    <div>
      <Route exact path="/" component={Home}/>
      <Route path="/about" component={About}/>
      <Route path="/why" component={WhyUs}/>
      <Route path="/services" component={Services}/>
      <Route path="/map" component={Maps}/>
      <Route path="/contact" component={ContactUs}/>
      <Route path="/thankyou" component={Thanks}/>
    </div>
  </Router>
)

const FooterMenu = () => (
            <footer>
          <div className="container">
          <div className="infobox-video">
          <div className="row pad-top-40">
            <div className="col-sm-12">
            <h1></h1> 
            </div>
          </div>
          </div>
        </div>  
        <div className="footer">
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
               <ul className="list-unstyled">
                <li><Link to="/about">About MVP</Link></li>
                <li><Link to="/why">Why MVP?</Link></li>
                <li><Link to="/services?section=services-temporary-staffing">Services</Link></li>
                <li><Link to="/map">LOCATIONS</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
              </div>
              <div className="col-sm-6 text-right">
                <div className="social">
                </div>
                <div className="cpt">
                  <ul className="list-unstyled">
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">  &copy; 2017 Most Valuable Personnel</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
)

const Home = () => (
  <div>
    <Nav />
    <Index />
    <FooterMenu />
  </div>
)

const About = () => (
  <div>
   <Nav />
    <Abouts />
    <FooterMenu />
  </div>
)

const WhyUs = () => (
  <div>
    <Nav />
    <Why />
    <FooterMenu />
  </div>
)

const Services = () => (
  <div>
    <Nav />
    <Service />
    <FooterMenu />
  </div>
)

const ContactUs = () => (
  <div>
    <Nav />
    <Contact />
    <FooterMenu />
  </div>
)

const Thanks = () => (
  <div>
    <Nav />
    <Thank />
    <FooterMenu />
  </div>
)

const Maps = () => (
  <div>
    <Nav />
    <Map />
    <FooterMenu />
  </div>
)

export default App


// WEBPACK FOOTER //
// ./src/App.js